import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import useClaimRedirect from 'module/claims/hooks/useClaimRedirect';
import { useState } from 'react';
import { useClaimEdit } from '../ClaimEdit.Hooks';
import ClaimEditCorrectionDetails from './ClaimEdit.CorrectionDetails';
import ClaimEditLegacyClaimHistory from './ClaimEdit.LegacyClaimHistory';

enum Actions {
  correctionDetails = 'correctionDetails',
}
export default function ClaimEditClaimHistory() {
  const { lang } = getLocales();
  const { contract, product, claimHistory, emailTemplates, statusInfo, navigateToTab } = useClaimEdit();
  const { finalRedirect } = useClaimRedirect({
    emailTemplates,
    statusInfo,
    navigateToTab,
  });

  const [data, setData] = useState<{ action: Actions | undefined; claim?: Model.IClaim }>({
    action: undefined,
    claim: undefined,
  });

  return (
    <>
      <h2 style={{ marginTop: 0 }}>{lang.claimHistory}</h2>
      {!claimHistory?.length && <ErrorWrapper children={lang.noInfo} />}
      {!!claimHistory?.length && (
        <table className={ThemeTableSimple}>
          <thead>
            <tr>
              <th>{lang.claim}</th>
              <th>{lang.info}</th>
              <th>{lang.incidentLocalDate}</th>
              {/* <th>{lang.decidedDate}</th>
              <th>{lang.paymentDate}</th> */}
              <th>{lang.createdAt}</th>
              <th>{lang.lastModified}</th>
              <th>{lang.status}</th>
              <th>{lang.owner}</th>
              <th data-actions>{lang.actions}</th>
            </tr>
          </thead>
          <tbody>
            {!claimHistory?.length && (
              <tr>
                <td colSpan={7}>{lang.noInfo}</td>
              </tr>
            )}
            <DataMap
              data={claimHistory}
              render={({ data: claim }) => (
                <tr key={claim.id}>
                  <td>
                    <b>{claim.number}</b>
                    <br />
                    {product?.name ?? lang.unknownProduct}
                  </td>
                  <td>
                    {lang.contact}: <b>{claim.createdByPayee?.name || 'N/A'}</b>
                    <br />
                    {lang.client}: <b>{contract?.client?.name ?? 'N/A'}</b>
                  </td>
                  <td>
                    {claim?.incidentLocalDate ? localizeDate(claim?.incidentLocalDate, defaultDateTimeFormat) : 'N/A'}
                  </td>
                  {/* <td>
                    {claim?.decidedDateUtc
                      ? date(claim?.decidedDateUtc, defaultServerDateTimeFormat).format(defaultDateTimeFormat)
                      : 'N/A'}
                  </td>
                  <td>
                    {claim?.paymentDateUtc
                      ? date(claim?.paymentDateUtc, defaultServerDateTimeFormat).format(defaultDateTimeFormat)
                      : 'N/A'}
                  </td> */}
                  <td>{date(claim?.createdAtUtc, defaultServerDateTimeFormat).format(defaultDateTimeFormat)}</td>
                  <td>{date(claim?.modifiedAtUtc, defaultServerDateTimeFormat).format(defaultDateTimeFormat)}</td>
                  <td>
                    <b>{lang[claim.statusCode]?.replace(/_/g, ' - ') || lang.noStatusDefined}</b>
                  </td>
                  <td>{claim.owner ? `${claim.owner?.firstName} ${claim.owner?.lastName}` : 'N / A'}</td>
                  <td style={{ display: 'flex', flexDirection: 'column', gap: Theme.Size.S }}>
                    <Button
                      onClick={finalRedirect}
                      data={claim}
                      class={ThemeButtonCircle}
                      media="fas-folder-open"
                      htmlElementProps={{
                        title: `${lang.open} ${lang.claim}`,
                      }}
                      render={lang.open}
                    />
                    <Button
                      onClick={setData}
                      data={{ action: Actions.correctionDetails, claim }}
                      class={ThemeButtonCircle}
                      media="fas-info"
                      htmlElementProps={{
                        title: `${lang.show} ${lang.correctionDetails}`,
                      }}
                      active
                      render={lang.details}
                      disabled={!claim.claimJobs?.length}
                    />
                  </td>
                </tr>
              )}
            />
          </tbody>
        </table>
      )}
      {data.action === Actions.correctionDetails && data.claim && (
        <ClaimEditCorrectionDetails onClose={() => setData({ action: undefined })} claim={data.claim} />
      )}
      {contract?.legacyId && <ClaimEditLegacyClaimHistory />}
    </>
  );
}
